import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import Plus from "../../assets/img/icons/plus_white.svg";
import RoundTab from "../../components/RoundTabButtons/RoundTab";
import FilterDropDownStyle from "../../components/DropdownStyle/FilterDropDownStyle";
import BottomPagination from "../../components/Pagination/BottomPagination/BottomPagination";
import TopPagination from "../../components/Pagination/TopPagination/TopPagination";
import PricingPlan from "../../components/PricingPlan";
import Select from "../../components/ReactSelectDropdown";
import ClearFilterButton from "../../components/Search/clearFilterButton";
import { setPathName } from "../../filterReducer";
import {
  ButtonIcon,
  ColoredButtonWithIcon,
} from "../../styledComponents/buttons";
import {
  CommonFlexWrap,
  CommonGrid,
  ContainerNew,
  FilterLabel,
  InputField,
  InputWithLabelSection,
  PageTitle,
} from "../../styledComponents/common";
import { FilterContainer } from "../../styledComponents/invoice";
import InvoiceTable from "./InvoiceTable";

const Invoice = ({
  selectedOrganization,
  getClientShortList,
  clientShortList,
  getInvoiceList,
  sendInvoiceEmailInfo,
  recordPaymentInfo,
  invoiceList,
  deletedInvoiceCallback,
  history,
  isLoading,
  sendMailLoading,
  recordPaymentLoading,
  paymentDetailsLoading,
  deleteInvoiceLoading,
  recordPaymentInvoice,
  createInvoiceUpdateSendLog,
  updateInvoiceSendLog,
  sendInvoiceEmail,
  profileData,
  getClientDetails,
  clientDetails,
  deleteInvoice,
  noData,
  filters,

  // pagination
  totalInvoicesCount,
  invoicePageSize,
  reloadInvoiceList,
}) => {
  const dispatch = useDispatch();
  const [clientOptions, setClientOptions] = useState([]);
  const [selectedClient, setSelectedClient] = useState(
    filters?.pathname === "/user/invoices" && filters?.selectedClient
      ? filters?.selectedClient
      : {
          label: "(All Customers)",
          value: "",
        }
  );

  const [selectedStatus, setSelectedStatus] = useState(
    filters?.pathname === "/user/invoices" && filters?.selectedStatus
      ? filters?.selectedStatus
      : {
          value: "",
          label: "(All)",
        }
  );
  const statusOptions = [
    { value: "", label: "(All)" },
    { value: "draft", label: "Draft" },
    { value: "sent", label: "Sent" },
    { value: "paid", label: "Paid" },
    { value: "partial", label: "Partially Paid" },
  ];
  const [sentState, setSentState] = useState(false);
  const [recordPaymentState, setRecordPaymentState] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const [pricingPopup, setPricingPopup] = useState(false);

  // pagination
  const [currentPageNumber, setCurrentPageNumber] = useState(1);

  const callGetInvoiceList = (background = false) => {
    if (selectedOrganization && selectedOrganization.id) {
      const payload = {
        organization_id: selectedOrganization.id,
        page: currentPageNumber,
      };
      background && (payload.background = true);
      if (selectedClient && selectedClient.value) {
        payload.client_id = selectedClient.value;
      }
      if (selectedStatus && selectedStatus.value) {
        payload.status = selectedStatus.value;
      }
      getInvoiceList(payload);
    }
  };

  useEffect(() => {
    callGetInvoiceList();
  }, [selectedOrganization, selectedClient, selectedStatus, currentPageNumber]);
  useEffect(() => {
    reloadInvoiceList && callGetInvoiceList();
  }, [reloadInvoiceList]);

  useEffect(() => {
    dispatch(
      setPathName({
        pathname: location.pathname,
        selectedStatus,
        selectedClient,
      })
    );
  }, [selectedStatus, selectedClient]);

  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      setCurrentPageNumber(1);
      const payload = {
        organization_id: selectedOrganization.id,
      };
      getClientShortList(payload);
    }
    if (
      selectedOrganization?.plan?.name === "Standard" ||
      selectedOrganization?.plan?.nick_name === "standard-free"
    ) {
      pricingPopupToggle();
    }
  }, [selectedOrganization]);

  useEffect(() => {
    if (clientShortList && clientShortList.length > 0) {
      const options = [];
      clientShortList.map((item) => {
        options.push({
          value: item.id,
          label: item.name,
        });
      });
      options.unshift({ label: "(All Customers)", value: "" });
      setClientOptions(options);
    } else if (clientShortList && clientShortList.length === 0) {
      setClientOptions([]);
    }
  }, [clientShortList]);

  // useEffect(() => {
  //   if (
  //     selectedOrganization &&
  //     selectedOrganization.id &&
  //     sendInvoiceEmailInfo &&
  //     sendInvoiceEmailInfo.log_id &&
  //     sentState
  //   ) {
  //     const payload = {
  //       organization_id: selectedOrganization.id,
  //       background: true,
  //     };
  //     const timer = setTimeout(() => {
  //       getInvoiceList(payload);
  //     }, 4000);
  //     return () => clearTimeout(timer);
  //   }
  // }, [sendInvoiceEmailInfo]);

  useEffect(() => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      recordPaymentInfo &&
      recordPaymentInfo.id &&
      recordPaymentState
    ) {
      callGetInvoiceList(true);
    }
  }, [recordPaymentInfo]);

  const handlePageChange = (page) => {
    setCurrentPageNumber(page);
  };

  const onClientSelect = (e) => {
    if (selectedOrganization && selectedOrganization.id) {
      setCurrentPageNumber(1);
    }
    setSelectedClient(e);
  };

  // useEffect(() => {
  //   if (
  //     selectedOrganization &&
  //     selectedOrganization.id &&
  //     deletedInvoiceCallback &&
  //     deleted
  //   ) {
  //     const payload = {
  //       organization_id: selectedOrganization.id,
  //     };
  //     getInvoiceList(payload);
  //   }
  // }, [deletedInvoiceCallback]);

  const onStatusSelect = (e) => {
    setSelectedStatus(e);
  };

  const onSend = () => {
    setSentState(true);
  };

  const onRecordPay = () => {
    setRecordPaymentState(true);
  };

  const onDelete = () => {
    setDeleted(true);
  };

  const pricingPopupToggle = () => {
    setPricingPopup(!pricingPopup);
  };

  return (
    <div className="content">
      <PricingPlan
        isOpen={pricingPopup}
        toggle={pricingPopupToggle}
        popupText="You don't have permission to this feature."
        popupTitle="Upgrade to Elite to access this feature"
        history={history}
        backRoute="/user/dashboard"
        onlyElite
      />
      <ContainerNew>
        <CommonGrid alignItem="center">
<PageTitle>Invoices</PageTitle>
<ColoredButtonWithIcon
          style={{ alignSelf: "flex-end" }}
          margin="0 0 0 auto"
          onClick={() => history.push("/user/create-invoice")}
        >
          <ButtonIcon src={Plus} />
          Create New Invoice
        </ColoredButtonWithIcon>
        </CommonGrid>
      
      <FilterContainer columns="auto minmax(auto, 150px)" marginTop="0px" responsiveBreakpoint="685px">
         <CommonFlexWrap responsiveBreakpoint="405px" responsiveColumns="auto" columns="auto auto auto auto auto" gap="5px">
            <RoundTab
              text="All"
              selected={selectedStatus?.value === ""}
              onClick={() => onStatusSelect({ value: "", label: "(All)" })}
              showIcon={false}
            />
            <RoundTab
              text="Draft"
              selected={selectedStatus?.value === "draft"}
              onClick={() => onStatusSelect({ value: "draft", label: "Draft" })}
              showIcon={false}
            />
            <RoundTab
              text="Sent"
              selected={selectedStatus?.value === "sent"}
              onClick={() => onStatusSelect({ value: "sent", label: "Sent" })}
              showIcon={false}
            />
            <RoundTab
              text="Paid"
              selected={selectedStatus?.value === "paid"}
              onClick={() => onStatusSelect({ value: "paid", label: "Paid" })}
              showIcon={false}
            />
            <RoundTab
              text="Partially Paid"
              selected={selectedStatus?.value === "partial"}
              onClick={() => onStatusSelect({ value: "partial", label: "Partially Paid" })}
              showIcon={false}
            />
          </CommonFlexWrap>
        <InputWithLabelSection>
          <FilterLabel>Customer</FilterLabel>
          <Select
            value={selectedClient}
            isClearable={selectedClient?.value}
            options={clientOptions}
            onChange={(e) =>
              e
                ? onClientSelect(e)
                : onClientSelect({
                    label: "(All Customers)",
                    value: "",
                  })
            }
            placeholder="Select Customer..."
            styles={FilterDropDownStyle({ height: "40px" })}
            components={{
              IndicatorSeparator: () => null,
              ClearIndicator: (props) => {
                return <ClearFilterButton {...props} />;
              },
            }}
          />
        </InputWithLabelSection>

         
        
      </FilterContainer>

      {totalInvoicesCount && totalInvoicesCount > 0 && invoicePageSize ? (
        <TopPagination
          itemName="invoices"
          totalCount={totalInvoicesCount}
          currentPage={currentPageNumber}
          onPageChange={(page) => handlePageChange(page)}
          pageSize={invoicePageSize}
        />
      ) : null}

      {selectedOrganization && selectedOrganization.id && profileData && (
        <InvoiceTable
          isLoading={isLoading}
          sendMailLoading={sendMailLoading}
          recordPaymentLoading={recordPaymentLoading}
          paymentDetailsLoading={paymentDetailsLoading}
          deleteInvoiceLoading={deleteInvoiceLoading}
          selectedOrganization={selectedOrganization}
          invoiceList={
            selectedStatus?.value
              ? invoiceList.filter(
                  (inv) => inv.status === selectedStatus?.value
                )
              : invoiceList
          }
          reloadInvoiceList={
            Math.ceil(totalInvoicesCount / invoicePageSize) != currentPageNumber
          }
          history={history}
          recordPaymentInvoice={recordPaymentInvoice}
          createInvoiceUpdateSendLog={createInvoiceUpdateSendLog}
          updateInvoiceSendLog={updateInvoiceSendLog}
          sendInvoiceEmail={sendInvoiceEmail}
          senderName={profileData && profileData.first_name}
          getClientDetails={getClientDetails}
          clientDetails={clientDetails}
          deleteInvoice={deleteInvoice}
          onSend={onSend}
          onRecordPay={onRecordPay}
          onDelete={onDelete}
          noData={noData}
          selectedClient={selectedClient}
          selectedStatus={selectedStatus}
        />
      )}

      {totalInvoicesCount && totalInvoicesCount > 0 && invoicePageSize ? (
        <BottomPagination
          totalCount={totalInvoicesCount}
          currentPage={currentPageNumber}
          onPageChange={(page) => handlePageChange(page)}
          pageSize={invoicePageSize}
        />
      ) : null}
      </ContainerNew>
    </div>
  );
};

export default Invoice;
